import UserHistoryRate from './UserHistoryRate';

export default UserHistoryRate;